<template>
  <div class="module_page page_content institution">
  
    <div class="row page-heading">
      <div class="col-8 input module_heading" role="heading" aria-level="1">
        <span class="module_icon ic-inst"></span>
        <label class="head_txt module_type_name institution-title ace_sec_hd">{{institution.displayName}}</label>
      </div>
      <div class="col-4 btn_container text-right">
        <b-btn @click="showDeleteLinkConfirm" v-if="selfRegistrationLink">delete</b-btn>
        <b-btn @click="generate" v-else>generate</b-btn>
      </div>
    </div>
    
    <div class="page_content_container">
    
      <institution-menu :uuid="uuid" :active="'selfRegistration'"></institution-menu>
    
      <div class="row pg_content">
		    <div class="col-12">
          <div class="course-management-section">
            <div class="page_subheading">
              <div class="col-5" style="padding-left: 0px;"></div>              
            </div>

            <div class="course-management-table-container">
              <table class="table b-table table-bordered border">
                <thead class="thead-light text-center">
                  <tr>
                    <th class="first-column text-center">Self Registration Link</th>
                  </tr>
                </thead>
                <tbody v-if="selfRegistrationLink">
                  <tr>
                    <td class="first-column">{{selfRegistrationLink}}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="5" class="no-result" style="text-align: center;">Self Registration link is not available.</td>
                  </tr>
                </tbody>
              </table>
              <table class="table b-table table-bordered border">
                <thead class="thead-light text-center">
                  <tr>
                    <th class="first-column text-center">Institution Login Link</th>
                  </tr>
                </thead>
                <tbody v-if="selfSigninLink">
                  <tr>
                    <td class="first-column">{{selfSigninLink}}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="5" class="no-result" style="text-align: center;">Institution Login Link is not available.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          
        </div>
      </div>

    </div>

    <div>
      <b-modal class="delete-folder-popup" ref="deleteLinkConfirmModal" no-close-on-backdrop no-close-on-esc centered>
        <div style="text-align: center;">
          <h6>Are you sure you want delete the self registration link?</h6>
        </div>
        <div slot="modal-header" class="header-section">
          <div class="popup-heading">Please Confirm!</div>
          <button class="btn_close" aria-label="close" @click="cancelDeleteLink">
            <span class="ic-close"></span>
          </button>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-button @click="deleteLink" class="btn button-primary next float-right mr-2" aria-label="yes"> yes </b-button>
          <b-button @click="cancelDeleteLink" class="btn button-primary next float-right mr-2" aria-label="cancel"> no </b-button>
        </div>
      </b-modal>
    </div>
    
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import InstitutionMenu from './InstitutionMenu'  

  export default {
    name: 'selfRegistrationLinkConfiguration',
    props: ['uuid'],
    components: {
      InstitutionMenu
    },
    methods: {
      ...mapActions([
        'loadGenerateSelfRegistrationLink',
        'loadDeleteSelfRegistrationLink'
      ]),
      async generate () {
        await this.loadGenerateSelfRegistrationLink(this.uuid)
      },
      showDeleteLinkConfirm () {
        this.$refs.deleteLinkConfirmModal.show()
      },
      cancelDeleteLink () {
        this.$refs.deleteLinkConfirmModal.hide()
      },
      deleteLink () {
        this.loadDeleteSelfRegistrationLink(this.uuid).then(resp => {
          this.cancelDeleteLink()
          if (resp) {
            this.notifySuccess('Self registration link deleted successfully.')
          } else {
            this.notifyFailure('Failed to delete self registration link.')
          }
        })
      },
      notifySuccess (text) {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: text
        })
      },
      notifyFailure (text) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: text
        })
      }
    },
    computed: {
      ...mapState({
        'institution': state => state.institution.institution,
        'selfRegistrationLink': state => state.institution.selfRegistrationLink,
        'selfSigninLink' : state => state.institution.selfSigninLink
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/institution/components/SelfRegistrationLinkConfiguration.vue